import PackagingUnitDocuments from '../../packagingUnitDocuments';

const DocumentsTab = ({ unit, description }) => (
    <div>
        {description && (
            <p className="text-muted small mb-3" style={{ whiteSpace: 'nowrap' }}>{description}</p>
        )}
        <PackagingUnitDocuments unit={unit} />
    </div>
);

export default DocumentsTab;
